module.exports = __webpack_public_path__ + "images/14-04_55b612f5.jpg";